import {
  aromaPopover,
  AromaPopoverVariantProps,
} from "@zenchef/styled-system/recipes";
import { createStyleContext, Slot } from "../../utils/createStyleContext";
import { Popover as ArkPopover, Assign } from "@ark-ui/react";
import { HTMLStyledProps } from "@zenchef/styled-system/types";
import { popoverSlots } from "../../theme/recipes/popover";

const { withProvider, withContext } = createStyleContext(aromaPopover);

export type PopoverSlots = Slot<typeof aromaPopover>;

export const slotsMaps: Record<PopoverSlots, PopoverSlots> =
  popoverSlots.reduce(
    (acc, slot) => ({ ...acc, [slot]: slot }),
    {} as Record<PopoverSlots, PopoverSlots>,
  );

export const PopoverRoot = withProvider<
  HTMLDivElement,
  Assign<
    HTMLStyledProps<"div">,
    ArkPopover.RootProps & AromaPopoverVariantProps
  >
>(ArkPopover.Root, slotsMaps.root);

export const PopoverPositioner = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<"div">, AromaPopoverVariantProps>
>(ArkPopover.Positioner, slotsMaps.positioner);

export const PopoverContent = withContext<
  HTMLDivElement,
  Assign<
    HTMLStyledProps<"div">,
    ArkPopover.ContentProps & AromaPopoverVariantProps
  >
>(ArkPopover.Content, slotsMaps.container);
